import React from 'react'
import { IconWithConfettiProps } from "./IconWithConfetti.types"
import stylesheet from "./IconWithConfetti.module.scss"

export default function IconWithConfetti({ largeShadow, largeIcon, className, style, children }: IconWithConfettiProps) {
  return (
    <div
      className={`${stylesheet.confetti} ${className ?? ""}`}
      style={style}
    >
      <div
        className={stylesheet.icon}
        style={{ height: largeIcon ? "70%" : "60%" }}
      >
        {children}
      </div>
      <div
        className={stylesheet.shadow}
        style={{ height: largeShadow ? "20%" : "10%" }}
      >
      </div>
    </div>
  )
}
